import OneThirdsImageOnLeft from "src/components/articledisplays/OneThirdsImageOnLeft";
import ButtonLink from "src/components/buttonlink/ButtonLink";
import PopularMoviesList, { prefetch } from "src/components/popularmovieslist/PopularMoviesList";
import classNames from 'classnames';
import styles from './OneArticleAndPopMovies.module.css';
import IFilmnytt from "src/lib/types/Filmnytt";
import { GroupedLayoutObject, IOneArticleAndPopMovies } from "src/lib/types/IForsidenV2";
import ISettings from "src/lib/types/Settings";

//#region [Props]
type OneArticleAndPopMoviesProps = {
    block: GroupedLayoutObject<IOneArticleAndPopMovies>;
    settings: ISettings;
};
//#endregion

const IMG_SIZES = `(min-width: 550px) 800px, 250px`;

export { prefetch };

//#region [Component]
export default function OneArticleAndPopMovies({ block, settings }: OneArticleAndPopMoviesProps) {
    return <div className={classNames(styles.SOneArticleAndPopMovies, { [styles.isAtTop]: !settings.messageBannerActive })}>
        <div className={styles.SContentContainer}>
            <OneThirdsImageOnLeft className={styles.SOneThirdsImageOnLeft} document={block.articles![0] as IFilmnytt} sizes={IMG_SIZES} />
            <PopularMoviesList className={styles.SPopularMoviesList} hideHeader />
        </div>
        {block.linkTitle && block.linkUrl && <ButtonLink className={styles.SButtonLink} href={block.linkUrl}>{block.linkTitle}</ButtonLink>}
    </div>;
}
//#endregion
